import { getCouponTitle } from '../../Utils'

export const generateResultPage = (data, coupon) => {
  const giftImage = data.imgGift?.url || ''
  const title = getCouponTitle(data.text?.content, coupon.text) || ''
  const titleStyle = data.text?.style || {}
  const code = getCouponTitle(data.code?.content, coupon.text) || ''
  const codeStyle = data.code?.style || {}
  const text_2 = getCouponTitle(data.text_2?.content, coupon.text) || ''
  const text_2Style = data.text_2?.style || {}
  const buttonText = data.button?.content || ''
  const buttonStyle = data.button?.style || {}

  const html = `
    <div id="kariba_overlay_container">
      <div id="kariba_result_container_result"
        style="background: url(${data?.background.url || ''}) no-repeat;">
        <div id="kariba_close_spin_game"><i class="material-icons">&#xe5cd;</i></div>
        <img id="kariba_spin_gift_image" src=${giftImage} alt="gift image" class="kariba-image-decorator"
          style="width: 110px; height: 110px; 
          margin-bottom: 33px;" />
        <span style="font-family: ${titleStyle.fontFamily || 'Inter'}; 
          color: ${titleStyle.color || '#FA541C'};
          font-size: ${titleStyle.fontSize || 36}px;
          font-weight: ${titleStyle.fontStyle || 'bold'};
          text-align: ${titleStyle.textAlign || 'center'};
          margin-bottom: 16px;
          width: 600px;
          max-height: 104px;
          ">${title}</span>

        <span style="font-family: ${codeStyle.fontFamily || 'Inter'}; 
          color: ${codeStyle.color || '#000000'};
          font-size: ${codeStyle.fontSize || 20}px;
          font-weight: ${codeStyle.fontStyle || 'bold'};
          text-align: ${codeStyle.textAlign || 'center'};
          width: 600px;
          margin-bottom: 16px;
          ">${code}</span>

        <span style="font-family: ${text_2Style.fontFamily || 'Inter'}; 
          color: ${text_2Style.color || '#FA541C'};
          font-size: ${text_2Style.fontSize || 20}px;
          font-weight: ${text_2Style.fontStyle || 'bold'};
          text-align: ${text_2Style.textAlign || 'center'};
          margin-bottom: 24px;
          ">${text_2}</span>

        <button
          id="kariba_continue_shopping"
          style="font-family: ${buttonStyle.fontFamily || 'Inter'}; 
          background-color: ${buttonStyle.backgroundColor || '#FA541C'};
          color: ${buttonStyle.color || '#FFF'};
          font-size: ${buttonStyle.fontSize || 12}px;
          font-weight: ${buttonStyle.fontStyle || 'nomal'};
          text-align: ${buttonStyle.textAlign || 'center'};
          padding: 4px 16px;
          min-width: 298px;
          height: 40px;
          border-radius: 4px;
          border: none;
          outline: none;
          margin-bottom: 15px;
          cursor: pointer"
          >${buttonText}</button>
          <canvas id="kariba_effect_canvas"></canvas>
      </div>
      <div id="effect_wrapper"></div>
    </div>  
    `
  // Append result page
  document.body.innerHTML += html
  let closeSpinGame = document.getElementById('kariba_close_spin_game')
  closeSpinGame.addEventListener('click', () => {
    document.getElementById('kariba_overlay_container')?.remove()
  })
}
